import { useQueryClient } from "@tanstack/react-query";
import { useEventSubscription } from "~/hooks/useEventSubscription";
import { useCurrentWorkspace } from "~/providers/CurrentWorkspaceProvider";
import { getPrivateTranscriptInfoKey } from "~/swr-hooks/clips/transcript/useGetPrivateClipTranscriptInfo";
import { getClipWithoutWorkspaceIdKey } from "~/swr-hooks/useGetClipWithNoWorkspaceId";
export const useUpdatePrivateTranscriptWhenCompleted = (param)=>{
    let { clipId } = param;
    const { currentWorkspace } = useCurrentWorkspace();
    const queryClient = useQueryClient();
    useEventSubscription({
        currentWorkspaceId: currentWorkspace === null || currentWorkspace === void 0 ? void 0 : currentWorkspace.id,
        event: clipId ? {
            eventType: "System.Asset.Version.Transcript.updated",
            pattern: {
                clipId,
                update: {
                    status: "complete"
                }
            }
        } : undefined,
        options: {
            onUpdate: async ()=>{
                if (!clipId) return;
                const clipKey = getClipWithoutWorkspaceIdKey({
                    clipId
                });
                await queryClient.invalidateQueries({
                    queryKey: clipKey
                });
                const transcriptInfoKey = getPrivateTranscriptInfoKey(clipId);
                queryClient.resetQueries({
                    queryKey: transcriptInfoKey
                });
            }
        }
    });
};
